import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke111aRequest, Sgke111aResponse, Sgke111aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke111aService {

  /**
   * コンストラクタ
   * @param {Sgke111aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke111aService
   */
  constructor(
    public service: Sgke111aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * Sgke111aAPI実行
   *
   * @param {Sgke111aRequest} request
   * @return {*}  {Observable<Sgke111aResponse>}
   * @memberof UsedSgke111aService
   */
  public doSgke111a(request: Sgke111aRequest): Observable<Sgke111aResponse> {

    return this.service.sgke111aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE111A');
          return throwError(err.message);
        })
      );
  }

}

